import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=53f8fc8c&"
import script from "./Facebook.vue?vue&type=script&lang=ts&"
export * from "./Facebook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports